export default "__VITE_ASSET__BcEkBfXV__"